import moment from 'moment';

export type AgendaEvent = { name: string };
export type AgendaByDate = { [date: string]: AgendaEvent[] };
export type CalendarByDate = { [date: string]: any };

export function mapDayEventsToAgenda(dayData: any): AgendaEvent[] {
  if (!dayData?.event || !Array.isArray(dayData.event)) {
    return [];
  }

  return dayData.event.map((element: any) => ({ name: element.name }));
}

export function buildAgendaFromCalendar(
  calendarData: CalendarByDate | null | undefined
): { calendar: CalendarByDate; agenda: AgendaByDate } {
  const calendar: CalendarByDate = {};
  const agenda: AgendaByDate = {};

  if (!calendarData || typeof calendarData !== 'object') {
    return { calendar, agenda };
  }

  Object.keys(calendarData).forEach((strTime) => {
    const day = calendarData[strTime];
    const events = mapDayEventsToAgenda(day);

    if (events.length > 0) {
      calendar[strTime] = {
        dots: [{ key: 'event', color: 'grey' }],
        event: day.event || [],
      };
    } else {
      calendar[strTime] = {};
    }

    agenda[strTime] = events;
  });

  return { calendar, agenda };
}

export function buildAgendaForDateRange(
  calendarData: CalendarByDate | null | undefined,
  startDate: moment.Moment,
  endDate: moment.Moment
): AgendaByDate {
  const agenda: AgendaByDate = {};
  const source = calendarData && typeof calendarData === 'object' ? calendarData : {};

  for (let date = startDate.clone(); date.isSameOrBefore(endDate); date.add(1, 'day')) {
    const strTime = date.format('YYYY-MM-DD');
    agenda[strTime] = mapDayEventsToAgenda(source[strTime]);
  }

  return agenda;
}

export function ensureDateRangeKeys(
  calendar: CalendarByDate,
  agenda: AgendaByDate,
  startDate: moment.Moment,
  endDate: moment.Moment
): void {
  for (let date = startDate.clone(); date.isSameOrBefore(endDate); date.add(1, 'day')) {
    const strTime = date.format('YYYY-MM-DD');
    if (!Object.prototype.hasOwnProperty.call(agenda, strTime)) {
      calendar[strTime] = {};
      agenda[strTime] = [];
    }
  }
}
